import React from 'react';
import { useApiError } from '../context/ApiErrorContext';

const ErrorAlert: React.FC = () => {
  const { error, clearError } = useApiError();

  if (!error) return null;

  return (
    <div 
      className="alert alert-danger alert-dismissible fade show" 
      role="alert"
      style={{ position: 'fixed', top: '10%', right: '10px', zIndex: 1050 }}
      >
      {error}
      <button type="button" className="btn-close" aria-label="Close" onClick={clearError}></button>
    </div>
  );
};

export default ErrorAlert;
